import React from "react";
import { StructuredText } from "react-datocms";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import styled from "styled-components";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const Link = dynamic(() => import("@/common/UI/Link"));

const IconBoxCardWithImageBelow = (props) => {
  const {
    icon,
    title,
    info,
    btnUrl,
    btnText,
    image,
    small,
    alt,
    iconTitle,
    target,
  } = props;

  const { siteConfig } = useSelector((state) => {
    return {
      siteConfig: state?.labelsConfig?.labelsAndConfigData?.siteConfig,
    };
  });

  const HoverBg = styled.a`
    a {
      &:hover {
        background: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        background: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;

  return (
    <>
      <div
        style={{
          backgroundColor: siteConfig?.brandBoxBackgroundColor?.hex,
        }}
        className={
          small
            ? "icon-box-card-with-image relative rounded-2xl size-sm"
            : "icon-box-card-with-image relative rounded-2xl"
        }
      >
        <div className="p-5 md:p-10">
          {icon && (
            <div>
              <div className="relative">
                <ImageUI
                  src={icon?.src || icon}
                  alt={alt}
                  title={iconTitle}
                  width={20}
                  height={20}
                />
              </div>
            </div>
          )}

          <div className="content mt-1">
            <h2
              className={
                small
                  ? "mb-2 font-extrabold h3-web tracking-wide"
                  : "mb-2 font-extrabold h2-web tracking-wide"
              }
            >
              {title}
            </h2>

            {typeof info === "string" ? (
              <h3
                className={
                  small
                    ? "p-web mt-3 mb-5 text-[#666] w-2/3 block"
                    : "h3-web mt-3 mb-5 text-[#666] w-2/3 xl:w-2/4 block"
                }
              >
                {info}
              </h3>
            ) : (
              <h3
                className={
                  small
                    ? "p-web mt-3 mb-5 text-[#666] w-2/3 block structure-format"
                    : "h3-web mt-3 mb-5 text-[#666] w-2/3 xl:w-2/4 block structure-format"
                }
              >
                <StructuredText data={info} />
              </h3>
            )}
            {/* <HoverBg> */}
            <Link
              href={btnUrl}
              target={target}
              style={{
                backgroundColor: siteConfig?.brandButtonDefaultColor?.hex,
              }}
              className={
                small
                  ? "btn  text-white inline-block px-8 text-xs"
                  : "btn  text-white inline-block"
              }
            >
              {btnText}
            </Link>
            {/* </HoverBg> */}
          </div>
        </div>
        {image && (
          <div className="img-bottom">
            <ImageUI src={image?.src || image} />
          </div>
        )}
      </div>
    </>
  );
};

export default IconBoxCardWithImageBelow;
